import { Component, OnInit } from '@angular/core';

// Services
import { DashboardService } from '../../../services/dashboard.service';
import { ModuleService } from '../../../services/modules.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-thumb-living-with-cancer',
  templateUrl: './thumb-living-with-cancer.component.html',
  styleUrls: ['./thumb-living-with-cancer.component.scss']
})
export class ThumbnailLivingWithCancerComponent implements OnInit {

  livingWithCancerUrl = null;

  getExternalLinks(): any {
    return JSON.parse(localStorage.getItem('external_links'));
  }

  constructor(private dashboardService: DashboardService,
    private moduleService: ModuleService,
    private storageService: StorageService) { }

  ngOnInit() {
    const externalLinks = this.getExternalLinks();
    if (externalLinks) {
      this.pushLinks();
    } else {
      const dashboard: any = this.dashboardService.getDashboard();
      dashboard.
        $observable
        .subscribe(
        () => {
          this.storageService.setExternalLinks(dashboard);
          this.pushLinks();
        });
    }
  }
  pushLinks() {
    const externalLinks = this.getExternalLinks();
    this.livingWithCancerUrl = externalLinks.livingWithcancer;
  }

  get isLivingCancerAvailable() {
    return this.moduleService.isLivingCancerAvailable();
  }

  goUrl() {
    window.open(this.livingWithCancerUrl, '_blank');
  }
}
